import React from 'react';

import './style.scss';

const UserIcon = () => {
  return (
    <svg className="uni-avatar__img--default" viewBox="0 0 32 32" version="1.1">
      <path
        d="M29.3727031,32 L29.3727031,32 L2.62729687,32 C2.65488812,30.5252738 2.85505423,
        29.4111443 3.20493144,28.5768946 C4.06081015,25.9850319 6.29991382,23.9602079 9.30802786,
        22.7647265 C11.2006059,24.1214409 13.522315,24.9191845 16.029981,24.9191845 C18.5365466,
        24.9191845 20.8571554,24.1214409 22.7508337,22.7647265 C26.1079591,
        24.0994341 28.5088924,26.4673574 29.0953716,29.504285 C29.0980048,29.5180932 29.1005293,
        29.5314103 29.1029491,29.5442533 C29.2625791,30.2233373 29.3546367,31.0343661 29.3727031,
        32 Z M7.22729234,13.3656557 C7.22729234,8.50437088 11.1675958,4.56296705 16.029981,
        4.56296705 C20.8912658,4.56296705 24.8315693,8.50437088 24.8315693,
        13.3656557 C24.8315693,18.2280408 20.8912658,22.1683443 16.029981,22.1683443 C11.1675958,
        22.1683443 7.22729234,18.2280408 7.22729234,13.3656557 Z"
        fillOpacity="0.4"
        fill="#E6F2FF"
      />
    </svg>
  );
};

export default UserIcon;



// WEBPACK FOOTER //
// ./src/avatars/__partials/user-icon.jsx